// @ts-nocheck
import { useNotEnoughRequestedStock } from "@store/Framework/Store/Bunzl/Components/ProductAddToCartButton/ProductAddToCartButtonHooks";
import { useCanShowInventory, useIsSignedInAndhasToBeSignedIn } from "@store/Framework/Store/Context/ContextHooks";
import InfosBox from "@store/Library/Components/Toolkit/InfosBox";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import React, { useEffect, useState } from "react";

type Props = HasProductContext;

const ProductDetailsNotEnoughStockMessage = ({
    productContext: {
        productInfo: { qtyOrdered, inventory },
    },
}: Props) => {
    const canShowInventory = useCanShowInventory();
    const isSignedInAndhasToBeSignedIn = useIsSignedInAndhasToBeSignedIn();
    const [notEnoughStockMessage, setNotEnoughStockMessage] = useState<
        string | React.DetailedReactHTMLElement<{}, HTMLElement> | React.DetailedReactHTMLElement<{}, HTMLElement>[]
    >("");
    const notEnoughRequestedStock = useNotEnoughRequestedStock(qtyOrdered, inventory?.qtyOnHand);

    useEffect(() => {
        if (inventory && notEnoughRequestedStock) {
            setNotEnoughStockMessage(
                siteMessage(
                    "Cart_ToManyQtyRequested",
                    inventory.qtyOnHand.toLocaleString(),
                    qtyOrdered.toLocaleString(),
                ),
            );
        } else {
            setNotEnoughStockMessage("");
        }
    }, [qtyOrdered, inventory]);

    if ((!canShowInventory && !isSignedInAndhasToBeSignedIn) || !inventory || !notEnoughStockMessage) {
        return null;
    }

    return (
        <>
            <InfosBox type="default" size="small">
                {notEnoughStockMessage}
            </InfosBox>
        </>
    );
};

export default withProductContext(ProductDetailsNotEnoughStockMessage);
